import { List } from '@store/abstract/List';

import type { LaboratoryTestResult } from 'chaika-frontend-types/frontend-cms';

import { LaboratoryTest } from './LaboratoryTest';

interface FilterParams {}

export class LaboratoryTestList extends List<LaboratoryTest, LaboratoryTestResult, FilterParams> {
    protected readonly identifiableFieldName: string = 'serviceId';

    public serialize(): LaboratoryTestResult[] {
        return this.values.map(item => item.serialize());
    }

    protected create(params: LaboratoryTestResult): LaboratoryTest {
        return new LaboratoryTest(params);
    }
}
